module.exports = __webpack_public_path__ + "static/media/icon_data-received.c81a8fd6.svg";